import { Stack } from 'expo-router';
import React from 'react';

function ConfirmYourAddressLayout() {
  return <Stack screenOptions={{ headerShown: false }} />;
}

export default ConfirmYourAddressLayout;
